import t from "../../../helpers/t";
import React from "react";
import {Biscuit, FormatHelper} from "../../../../utils";
import moment from 'moment';


export const Abschluss = React.forwardRef((props, ref) => {
    const { complete, clients, filter } = props;
    const currency = Biscuit.get('client.currency');
    let feesPayPal,feesCredit;
    feesPayPal = (complete?.sumFeesComplete?.PayPal || 0);
    feesCredit = (complete?.sumFeesComplete?.credit || 0);
    const feesTotal = (feesPayPal > 0?t('paypal')+': '+FormatHelper.currencyFormat(feesPayPal) + " " + currency:'')+(feesCredit >0?(feesPayPal>0?', ':'')+t('credit')+': '+FormatHelper.currencyFormat(feesCredit) + " " + currency:'');
    const hasClient = (filter?.client_id || false);
    let dateString = '';
    if(typeof filter.date_gte !== 'undefined'){
        dateString += moment(filter.date_gte).format('DD.MM.YY');
    }
    if(typeof filter.date_lte !== 'undefined' && typeof filter.date_gte !== 'undefined'){
        dateString += ' - ' + moment(filter.date_lte).format('DD.MM.YY');
    }
    return (
        <>
            <style type="text/css" media="print">{"\
  @page {\ size: landscape;\ }\
"}</style>
            <div ref={ref} key={ref}>
                <h3 style={{textAlign:"center"}}>{t('income')+ (hasClient? " "+clients[filter.client_id]:" alle Clients") + " "+dateString}</h3>
                <table className="before_print" style={{marginTop:"30px"}} key={'tableA_'}>
                    <colgroup key={'tableA_ColGroup_'}>
                        {!hasClient && <col width="40%" key={'tableA_ColA_'}/>}
                        <col width="10%" key={'tableA_ColB_'}/>
                        <col width="10%" key={'tableA_ColC_'}/>
                        <col width="10%" key={'tableA_ColD_'}/>
                        <col width="10%" key={'tableA_ColE_'}/>
                        <col width="10%" key={'tableA_ColF_'}/>
                        <col width="10%" key={'tableA_ColG_'}/>
                        <col width="10%" key={'tableA_ColH_'}/>
                    </colgroup>
                    <thead style={{borderBottom:"1px solid grey"}} key={'tableA_Head_'}>
                    <tr key={'tableA_Head_TR_'}>
                        {!hasClient && <th  key={'tableA_Head_TR_TH1_'}>{t('client', null, 'capital')}</th>}
                        <th  style={{textAlign: "right"}} key={'tableA_Head_TR_TH20_'}>{t('income', null, 'capital')+' ('+t('gesamt', null, 'capital')+')'}</th>
                        <th  style={{textAlign: "right"}} key={'tableA_Head_TR_TH2_'}>{t('income', null, 'capital')+' ('+t('paypal')+')'}</th>
                        <th  style={{textAlign: "right"}} key={'tableA_Head_TR_TH21_'}>{t('income', null, 'capital')+' ('+t('credit')+')'}</th>
                        <th style={{textAlign: "right"}} key={'tableA_Head_TR_TH3_'}>{t('refunded', null, 'capital')+' ('+t('paypal')+')'}</th>
                        <th style={{textAlign: "right"}} key={'tableA_Head_TR_TH31_'}>{t('refunded', null, 'capital')+' ('+t('credit')+')'}</th>
                        <th style={{textAlign:"right"}} key={'tableA_Head_TR_TH4_'}>{t('fees', null, 'capital')+' ('+t('paypal')+')'}</th>
                        <th style={{textAlign:"right"}} key={'tableA_Head_TR_TH41_'}>{t('fees', null, 'capital')+' ('+t('credit')+')'}</th>
                    </tr>
                    </thead>
                    <tbody key={'tableA_TBODY_'}>
                {Object.keys(complete['sumIncomePerClient']).map((clientId) => {
                        let sums = 0;
                        let income = complete['sumIncomePerClient'][clientId];
                        let sumPaypalAdd = (income?.PayPal || 0);
                        let sumCreditAdd = (income?.credit || 0);
                        let refundPapal = (complete?.sumRefund[clientId]?.PayPal || 0);
                        let refundCredit = (complete?.sumRefund[clientId]?.credit || 0);
                        let feesPapal = (complete?.sumFees[clientId]?.PayPal || 0);
                        let feesCredit = (complete?.sumFees[clientId]?.credit || 0);
                        let com = sumPaypalAdd + sumCreditAdd;
                        return (<>
                            <tr className="sub-headline" style={{padding: "30px 0"}}
                                key={'tr_incomepp_' + clientId}>
                                {!hasClient &&  <td key={'tr_td1_name_' + clientId}>
                                    {clients[clientId]}
                                </td>}
                                <td className="paragraph-sum-total" style={{textAlign: "right"}}
                                    key={'tr_td2_incomecom_' + clientId + '_' + com}>
                                    {FormatHelper.currencyFormat(com) + " " + currency}
                                </td>
                                <td className="paragraph-sum-total" style={{textAlign: "right"}}
                                    key={'tr_td2_incomepp_' + clientId + '_' + sumPaypalAdd}>
                                    {FormatHelper.currencyFormat(sumPaypalAdd) + " " + currency}
                                </td>
                                <td className="paragraph-sum-total" style={{textAlign: "right"}}
                                    key={'tr_td2_incomec_' + clientId + '_' + sumCreditAdd}>
                                    {FormatHelper.currencyFormat(sumCreditAdd) + " " + currency}
                                </td>
                                <td className="paragraph-sum-total" style={{textAlign: "right"}}
                                    key={'tr_td2_refundpp_' + clientId + '_' + refundPapal}>
                                    {FormatHelper.currencyFormat(refundPapal) + " " + currency}
                                </td>
                                <td className="paragraph-sum-total" style={{textAlign: "right"}}
                                    key={'tr_td2_refundc_' + clientId + '_' + refundCredit}>
                                    {FormatHelper.currencyFormat(refundCredit) + " " + currency}
                                </td>
                                <td className="paragraph-sum-total" style={{textAlign: "right"}}
                                    key={'tr_td2_feepp_' + clientId + '_' + feesPapal}>
                                    {FormatHelper.currencyFormat(feesPapal) + " " + currency}
                                </td>
                                <td className="paragraph-sum-total" style={{textAlign: "right"}}
                                    key={'tr_td2_feec_' + clientId + '_' + feesCredit}>
                                    {FormatHelper.currencyFormat(feesCredit) + " " + currency}
                                </td>

                            </tr></>)


                    }
                )}
                    </tbody>
                    </table>
            <br/>
                <h3 style={{textAlign:'center'}} key={'h3_2'}>{t('sums for clients for stripe')}</h3>
                <table key={'complete_sums'}>
                    <colgroup key={'complete_sums_cg'}>
                        <col key={'sums_col1'} />
                        <col key={'sums_col2'} />
                    </colgroup>
                    <thead style={{borderBottom:"1px solid grey"}} key={'tableB_Head_'}>
                        <tr key={'tableB_thead_tr'}>
                            <th key={'tableB_thead_th1'}>
                                {t('client', null, 'capital')}
                            </th>
                            <th key={'tableB_thead_th2'} style={{textAlign: "right"}}>
                                {t('amount')}
                            </th>
                        </tr>
                    </thead>
                    <tbody key={'complete_sums_tbody'}>
                    {Object.keys(complete?.sumsForStripeClients).map((clientId) => {
                        let sum = (complete?.sumsForStripeClients[clientId] || 0);
                        return ( <>
                        {sum>0 && <><tr key={'complete_sums_tbody_tr_'+clientId}>
                               <td key={'complete_sums_tbody_tr_td1_'+clientId}>
                                   {clients[clientId]}
                               </td>
                               <td key={'complete_sums_tbody_tr_td2_'+clientId} style={{textAlign: "right"}}>
                                   {FormatHelper.currencyFormat(sum) + " " + currency}
                               </td>
                           </tr></>}
                        </>)
                    })}
                    </tbody>
                </table>
                <br/>
                <br/>
                <table key={'completeAll'}>
                    <colgroup key={'completeAll_cg'}>
                        <col key={'completeAll_cg_c1'}/>
                        <col key={'completeAll_cg_c2'}/>
                    </colgroup>
                </table>
                <tbody key={'completeAll_tbody'}>
                <tr key={'completeAll_tbody_tr1'}>
                    <td key={'completeAll_tbody_tr1_td1'}>
                        {t('sum to transfer from paypal')+':'}
                    </td>
                    <td key={'completeAll_tbody_tr1_td2'}>
                        {FormatHelper.currencyFormat((complete?.sumTransferFromPayPal || 0)) + " " + currency}
                    </td>
                </tr>
                <tr key={'completeAll_tbody_tr2'}>
                    <td key={'completeAll_tbody_tr2_td1'}>
                        {t('sum to transfer to stripe')+':'}
                    </td>
                    <td key={'completeAll_tbody_tr2_td2'}>
                        {FormatHelper.currencyFormat((complete?.sumTransferToStripeComplete || 0)) + " " + currency}
                    </td>
                </tr>
                <tr key={'completeAll_tbody_tr3'}>
                    <td key={'completeAll_tbody_tr3_td1'}>
                        {t('sum fees')+':'}
                    </td>
                    <td key={'completeAll_tbody_tr3_td2'}>
                        {feesTotal}
                    </td>
                </tr>
                </tbody>
            </div>
        </>
    )
});